import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-notice',
  templateUrl: './modal-notice.component.html',
  styleUrls: ['./modal-notice.component.scss']
})
export class ModalNoticeComponent implements OnInit {

    @Input() title: any;

    @Output() clickClose = new EventEmitter();
    @Output() clickDismiss = new EventEmitter();

    constructor(
        public activeModal: NgbActiveModal
    ) { }

    ngOnInit() {

    }

    btnClose() {
        this.clickClose.emit('save');
        this.activeModal.close();
    }

    btnDismiss() {
        this.clickDismiss.emit('dismiss');
        this.activeModal.dismiss();
    }
}
